
import { NodeHeaderEditModeProps } from "./NodeHeaderTypes";

const NodeHeaderEditMode = ({
  editValue,
  setEditValue,
  onEditComplete,
  onKeyDown
}: NodeHeaderEditModeProps) => {
  return (
    <input
      type="text"
      value={editValue}
      onChange={(e) => {
        e.stopPropagation();
        setEditValue(e.target.value);
      }}
      onBlur={(e) => {
        e.stopPropagation();
        onEditComplete();
      }}
      onKeyDown={onKeyDown}
      onClick={(e) => e.stopPropagation()}
      className="h-5 py-0 px-1 text-xs w-full max-w-[120px] nodrag border-none bg-transparent focus:outline-none focus:bg-black/5"
      autoFocus
      style={{ pointerEvents: 'all' }}
    />
  );
};

export default NodeHeaderEditMode;
